export type ToastPayload = {
  id?: string;
  title: string;
  description?: string;
  variant?: 'success' | 'error' | 'info' | 'warning';
  duration?: number; // ms
};

type Listener = (t: Required<ToastPayload>) => void;
const listeners = new Set<Listener>();

export function onToast(fn: Listener) {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

function uid() {
  try { return crypto.randomUUID(); } catch { return 't-' + Date.now() + '-' + Math.random().toString(36).slice(2); }
}

export function toast(p: ToastPayload) {
  const t: Required<ToastPayload> = {
    id: p.id || uid(),
    title: p.title,
    description: p.description ?? '',
    variant: p.variant ?? 'info',
    duration: p.duration ?? 4000
  };
  listeners.forEach(fn => fn(t));
  return t.id;
}


